import {useEffect, useState, useRef} from 'react'
import {AddCommits} from './AddCommits'
import {Details} from './Details'
import axios from 'axios'
import CurrencyFormat from 'react-currency-format'
import Loader from 'react-js-loader'
import '../Style.css'
import RangeSlider from 'react-range-slider-input'
import 'react-range-slider-input/dist/style.css'
import {Dropdown} from 'react-bootstrap'
import { AddTracking } from './AddTracking'
import { Send, Eye } from 'react-ionicons'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { useLocation } from 'react-router-dom'

const Deals = () => {
  const [showCreateAppModal, setShowCreateAppModal] = useState(false)
  const [showCreateAppModal2, setShowCreateAppModal2] = useState(false)
  const [showCreateAppModalTracking, setShowCreateAppModalTracking] = useState(false)
  const [selectedFilter, setSelectedFilter] = useState("All")

  const [apiData, setApiData] = useState([])
  const [filteredData, setFilteredData] = useState([])
  const [searchValue, setSearchValue] = useState('')
  const [propsData, setPropsData] = useState([])
  const [loading, setLoading] = useState(false)
  const [changedColor, setChangedColor] = useState({})
  const [changedSize, setChangedSize] = useState({})

  const [hotDealExist, setHotDealExist] = useState(false)
  const [premiumDealExist, setPremiumDealExist] = useState(false)
  const [dealView,setDealView] = useState('card');

  const [sliderValues, setSliderValues] = useState({from: 0, to: 100000})

  const API_URL = process.env.REACT_APP_API_URL
  const DEALS_URL = `${API_URL}/deals`
  const ALL_DEALS_URL = `${API_URL}/deals-all`

  const location = useLocation();

  const userDetails = localStorage.getItem('kt-auth-react-v');
  const myUser = JSON.parse(userDetails);
  
  
  const getApiData = async () => {
    setLoading(true)
    try {
      await axios
        .post(ALL_DEALS_URL,{user_id:myUser.id})
        .then((res) => {
          const filteredData = res.data.data.filter(deal => {
            return !(
              deal.premium_deal_access === false &&
              deal.premium_deal === 1
            );
          });
          setApiData(filteredData);
          // setApiData(res.data.data)
          if(res.data.data.filter(item => item.hotdeal == 1).length > 0){
            setHotDealExist(true);
          }
          setLoading(false)
          console.log(res)
        })
        .catch((error) => {
          console.error(error)
          setLoading(false)
        })
    } catch (error) {
      console.error(error)
    }
  }

    useEffect(() => {
    if (location.state?.openDealDetailModal) {
      setShowCreateAppModal2(true);
      setPropsData(location.state.deal);
    }
    if (location.state?.openDealCommitModal) {
      setShowCreateAppModal(true);
      setPropsData(location.state.deal);
      setChangedColor(location.state.color);
      setChangedSize(location.state.size);
    }
  }, [location.state]);

  const handleSliderChange = (e) => {
    setSliderValues(() => ({
      from: e[0],
      to: e[1],
    }))
  }

  const onRetailData = () => {
    setFilteredData(
      apiData.filter((items) => {
        return items.retail == 1;
      })
    )
  }

  const belowCostData = () => {
    setFilteredData(
      apiData.filter((items) => {
        return items.below_cost == 1
      })
    )
  }

  const hotDealsData = () => {
    setFilteredData(
      apiData.filter((items) => {
        return items.hotdeal == 1
      })
    )
  }

  const onCommissionData = () => {
    setFilteredData(
      apiData.filter((items) => {
        return items.commission_status == 1
      })
    )
  }

  const onIphoneProData = () => {
    setFilteredData(
      apiData.filter((items) => {
        return /^iPhone 18 Pro(?! Max)/i.test(items.subtscategory);
      })
    );
  }

  const onIphoneProMaxData = () => {
    setFilteredData(
      apiData.filter((items) => {
        return /^iPhone 18 Pro Max/i.test(items.subtscategory);
      })
    );
  }

  const allActiveData = () => {
    setFilteredData(apiData)
  }

  const itemPrice = (val) => {
    var data = {}
    
    if (val.commission_status == 1) {
      const commission = parseFloat(val.default_color?.sizes[0].commission)
      data = {
        status: 1,
        orderPrice: parseFloat(val.default_color?.sizes[0].price).toFixed(2),
        actualPrice: parseFloat(val.default_color?.sizes[0].price).toFixed(2),
        commission: commission,
      }
    } else if (val.retail == 1) {
      data = {
        status: 0,
        orderPrice: parseFloat(val.default_color?.sizes[0].price).toFixed(2),
        actualPrice: parseFloat(val.default_color?.sizes[0].price).toFixed(2),
        commission: 0,
      }
    } else if (val.below_cost == 1) {
      data = {
        status: 1,
        orderPrice: parseFloat(val.default_color?.sizes[0].price).toFixed(2),
        actualPrice: parseFloat(val.default_color?.sizes[0].commission).toFixed(2),
        commission: 0,
      }
    }
      return data;

  }

  useEffect(() => {
    const filterOnSale = apiData.filter((items) => {
      return items.on_sale_now == 1
    })
    setFilteredData(filterOnSale)
  }, [apiData])

  useEffect(() => {
    getApiData()
  }, [])

  const handleSelect = (eventKey) => {
    setSelectedFilter(eventKey)
    if(eventKey == "Expired"){
      setFilteredData(
        apiData.filter((items) => {
          return items.status == 2
        })
      )
    } else if(eventKey == "In Stock") {
      setFilteredData(
        apiData.filter((items) => {
          return items.status == 1 && items.deal_stock == 'true'
        })
      )
    } else if(eventKey == "Commitment Full") {
      setFilteredData(
        apiData.filter((items) => {
          return items.deal_stock == 'false' && items.status !=2 ;
        })
      )
    } else if(eventKey == "Retail") {
      setFilteredData(
        apiData.filter((items) => {
          return items.retail == 1 ;
        })
      )
    } else if(eventKey == "Commission") {
      setFilteredData(
        apiData.filter((items) => {
          return items.commission_status == 1 ;
        })
      )
    } else if(eventKey == "Below Cost") {
      setFilteredData(
        apiData.filter((items) => {
          return items.below_cost == 1;
        })
      )
    } else if(eventKey == "iPhone Pro") {
      setFilteredData(
        apiData.filter((items) => {
          return /^iPhone 18 Pro(?! Max)/i.test(items.subtscategory);
        })
      );
    } else if(eventKey == "iPhone Pro Max") {
      setFilteredData(
        apiData.filter((items) => {
          return /^iPhone 18 Pro Max/i.test(items.subtscategory);
        })
      );
    } else {
      const filterOnSale = apiData.filter((items) => {
        return items.on_sale_now == 1
      })
      setFilteredData(filterOnSale)
    }
    } 

    const formatDate = (myDate) =>{
      const date = new Date(myDate);
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
      const day = String(date.getDate()).padStart(2, '0');
      const year = date.getFullYear();
    
      return `${month}-${day}-${year}`;
    }

    const getDealLabel = (item) =>{
      if(item.below_cost == 1){
        return(
        <span className="fs-7 py-1 px-2" style={{border:'1px solid #CC0202',color:'#CC0202',borderRadius:8,backgroundColor:'white'}}>Below Cost</span>
        )
      }
      if(item.commission_status == 1){
        return(
        <span className="fs-7 py-1 px-2" style={{border:'1px solid #7dbc00',color:'#7dbc00',borderRadius:8,backgroundColor:'white'}}>Commission</span>
        )
      }
      if(item.retail == 1){
        return(
        <span className="fs-7 py-1 px-2" style={{border:'1px solid #4168d1',color:'#4168d1',borderRadius:8,backgroundColor:'white'}}>Retail</span>
        )
      }
    }

    const getBelowCostPercentage = (currentPrice,actualPrice)=>{
      const percentChange = (((currentPrice - actualPrice) / actualPrice) * 100).toFixed(2);
      const display = (percentChange > 0 ? '+' : '') + percentChange + '%';
      return display;
    }

    const DealCardView = ({val,index})=>{
      return(
        <div key={index} className='col-sm-6 col-lg-4 col-xl-3 col-md-4'>
            <div className={`card mt-5 ${val.premium_deal === 1 ? 'premium-deal-card' : 'deal-card'}`} style={{paddingTop:0}}>
            {/* <div className={`card mt-5 ${val.premium_deal === 1 ? 'premium-deal-card' : 'deal-card'}`} style={{paddingTop:0,border:'5px solid #59dce6'}}> */}
              {/* <div className="d-flex justify-content-center border-bottom" style={{backgroundColor:'#eef6f8',borderRadius:'20px 20px 0 0'}}> */}
                {/* <img src={toAbsoluteUrl('media/images/primebigday-head-2026.png')} style={{height:'auto',borderRadius:'0px 0px 0 0',width:'100%'}} alt="" /> */}
                {/* <img src={'https://makemoneyormiles.com/media/images/primebigday-head-2026.png'} style={{height:'auto',borderRadius:'0px 10px 0 0',width:'100%'}} alt="" /> */}
              {/* </div> */}
            {val.hotdeal == 1 &&(
            <div class="hot-deal-label" 
            style={{
              position: 'absolute',
              top: '23px',
              left: '-27px',
              backgroundColor: '#14255d',
              color: 'white',
              padding: '5px 10px',
              fontWeight: 'bold',
              borderRadius: '5px',
              zIndex:5,
              width:'150px',
              display:'flex',
              alignItems:'center',
              justifyContent:'center',
              transform: 'rotate(-40deg)',
              transformOrigin: 'center',
              clipPath: 'polygon(17% 0, 77% 0, 100% 100%, 0 100%)',
            }}
            ><span>Hot Deal</span></div>
            )}
            {val.business_deal == 1 && (
              <div className="biz-deal-label"
              style={{
                position: 'absolute',
                top: '0px',
                left: '15px',
                // backgroundColor: 'rgb(207, 222, 255)',
                backgroundColor: 'rgba(255, 255, 255, 1)',
                border: '2px solid rgb(207, 222, 255)',
                borderTop: '0',
                color: '#000000',
                padding: '5px 10px 10px 10px',
                zIndex:5,
                borderRadius: '0 0 15px 15px',
              }}
              >
                <div className='d-flex flex-column align-items-center justify-content-center'>
                  <i class="bi bi-bookmark-star-fill" style={{fontSize:30,color:'#0033a1ff'}}></i>
                  <span style={{fontSize:12}}>Business</span>
                </div>
              </div>
            )}
            {/* {val.hotdeal == 1 &&(
            <div class="hot-deal-label"><span>Hot Deal</span></div>
            )} */}
            {val.premium_deal == 1 &&(
            <div class="premium-deal-label"><span>EXCLUSIVE</span></div>
            )}
              <div className='ribbon ribbon-end ribbon-clip' style={{top: '10px'}}>
                {val.status === 1 ? (
                  <div className='ribbon-label' style={{zIndex:2,borderRadius:25}}>
                    {val.deal_stock == 'true' ? 'In Stock' : 'Commitment Full'}
                    {val.deal_stock == 'true' ? (
                      <span className='ribbon-inner bg-info' style={{borderTopLeftRadius:25,borderBottomLeftRadius:25}}></span>
                    ) : (
                      <span className='ribbon-inner bg-warning' style={{borderTopLeftRadius:25,borderBottomLeftRadius:25}}></span>
                    )}
                  </div>
                ) : (
                  <div className='ribbon-label' style={{zIndex:2,borderRadius:25}}>
                    Expired
                    <span className='ribbon-inner bg-danger' style={{borderTopLeftRadius:25,borderBottomLeftRadius:25}}></span>
                  </div>
                )}
              </div>
              <div className='px-5 py-3'>
                <div className={`card mt-5 ${val.premium_deal === 1 ? 'card card-body' : ''}`}  style={{position:'relative'}}>
                <div className="text-center">
                  <img
                    src={val.default_color && val.default_color?.image}
                    alt='val.name'
                    style={{
                      width: '100%',
                      height: '200px',
                      maxHeight: '450px',
                      objectFit: 'contain',
                      // padding:'10px'
                    }}
                  />
                  </div>
                  <div className="container-fluid text-left" style={{position:'absolute',bottom:'10px'}}>
                  {getDealLabel(val)}
                  </div>
                </div>
                <div className='mt-3'>
                  <div className='d-flex align-items-center'>
                    <div className='d-flex align-items-center flex-wrap w-100'>
                      <div className='px-3 flex-grow-1'>
                        <a className={`fs-5 fw-semibold text-hover-dark deal_description ${val.premium_deal === 1 ? 'text-dark' : 'text-gray-700'}`} style={{marginLeft:10}}>
                          {val.name}-{val?.default_color && val.default_color?.color}
                        </a>
                        <div className="container-fluid">
                          <div className="expire-date mb-2 mt-2">
                          <h5 className="fs-7 text-primary">Deal Expires : {formatDate(val.expires)}</h5>
                          </div>
  
                        </div>
                        <div className="row mt-3" style={{marginLeft:5}}>
                          <div className="col-lg-8">
                          <div className='d-flex flex-column justify-content-start mb-2'>
                          <span className={`fs-4 fw-bold ${val.premium_deal === 1 ? 'text-dark' : 'text-success'}`}>
                            <CurrencyFormat
                              decimalScale={2}
                              value={itemPrice(val).orderPrice}
                              displayType={'text'}
                              thousandSeparator={true}
                              prefix={'$'}
                            />
                            {(val.below_cost == 1 && itemPrice(val).actualPrice != 0) && (
                            <span className="fs-8 py-1 px-2 ms-2" style={{color:'#ffffffff',borderRadius:8,backgroundColor:'#ff8484ff'}}>{getBelowCostPercentage(itemPrice(val).orderPrice,itemPrice(val).actualPrice)}</span>
                              )}
                            </span>
                          {itemPrice(val).orderPrice === itemPrice(val).actualPrice && (
                            <h6 className="fs-8 text-gray-600">Price</h6>
                          )}
                          {itemPrice(val).status === 1 && itemPrice(val).orderPrice != itemPrice(val).actualPrice && (
                            <span className='fs-4 text-muted text-decoration-line-through'>
                              <CurrencyFormat
                                decimalScale={2}
                                value={itemPrice(val).actualPrice}
                                displayType={'text'}
                                thousandSeparator={true}
                                prefix={'$'}
                              />
                            </span>
                          )}
                        </div>
                          </div>
                          <div className="col-lg-4">
                            <h5 className={`fs-6 fw-bold ${val.premium_deal === 1 ? 'text-dark' : 'text-gray-800'}`}>
                            <CurrencyFormat
                                  decimalScale={2}
                                  value={itemPrice(val).commission.toFixed(2)}
                                  // value={itemPrice(val).commission}
                                  displayType={'text'}
                                  thousandSeparator={true}
                                  prefix={'$'}
                                />
                            </h5>
                            <h6 className="fs-8 text-gray-600">Commission</h6>
                          </div>
                        </div>
                        
                      </div>
                    </div>
                  </div>
                </div>
                <div className='d-flex align-items-center'>
                  {val.status === 1 ? (
                  <div className='d-flex justify-content-around'>
                    {val.deal_stock == 'true' && val.freezed_status == 1 && (
                        <button
                        onClick={() => {
                          setShowCreateAppModal2(true)
                          setPropsData(val)
                        }}
                        type='button'
                        className='deal-btn btn btn-dark text-white mt-2 ml-5'
                      >
                        Deal Freezed{' '}
                      </button>
                    )}
                    {val.deal_stock == 'true' && val.freezed_status == 0 && (
                      <>
                      <button onClick={() => {
                        setShowCreateAppModal(true)
                        setPropsData(val);
                        setChangedColor(val.default_color);
                        setChangedSize(val.default_color.sizes[0]);
                    }} type='button' className='commit-btn btn btn-warning mt-2 ms-3 me-3'
                    style={{background: 'linear-gradient(90deg, #f2994a 0%, #f2c94c 100%)'}}
                      >Commit&nbsp;&nbsp;<Send color={'white'} height="15px" width="15px" /></button>
                      <button
                      onClick={() => {
                        setShowCreateAppModal2(true)
                        setPropsData(val)
                      }}
                      type='button'
                      className='deal-btn btn btn-warning mt-2 ml-5'
                      style={{background: 'linear-gradient(90deg, #000046 0%, #1cb5e0 100%)'}}
                    >
                      View Deal&nbsp;&nbsp;<Eye color={'white'} height="15px" width="15px" />{' '}
                    </button>
                      </>
                    )}
                    {val.deal_stock == 'false' && val.freezed_status == 0 && (
                      <button
                        onClick={() => {
                          setShowCreateAppModal2(true)
                          setPropsData(val)
                        }}
                        type='button'
                        className='deal-btn btn btn-light  mt-2 ml-5'
                        style={{border: '2px solid rgba(129,45,227,1)',color:'rgba(129,45,227,1)'}}
                      >
                        Commitment Full{' '}
                      </button>
                    )}
                  </div>
                ) : (
                  <div className="d-flex justify-content-around">
                  <button
                  onClick={() => {
                    setShowCreateAppModal2(true)
                    setPropsData(val)
                  }}
                  type='button'
                  className='deal-btn btn btn-light  mt-2 ml-5'
                  style={{border: '2px solid rgba(129,45,227,1)',color:'rgba(129,45,227,1)'}}
                >
                  Expired{' '}
                </button>
                </div>
                )}
                
              </div>
              <div className="border-bottom my-3"></div>
                  <div className='d-flex flex-column mt-2'>
                    {/* <div className='text-dark fw-bold'>Stores</div> */}
                    <div className='d-flex'>
                      {val.default_color?.sizes[0].stores.map((item, index) => {
                        return (
                          <a
                            key={index}
                            href={item?.store_url}
                            target='_blank'
                            className='symbol symbol-40px me-2 card shadow-xs p-1'
                            style={{borderRadius:'50%'}}
                            data-bs-toggle='tooltip'
                            title={item?.store?.name}
                          >
                            <img
                              src={item?.store?.image}
                              alt='store'
                              style={{height: '30px', width: ' 30px'}}
                            />
                          </a>
                        )
                      })}
                    </div>
                  </div>
              </div>
            </div>
          </div>
      )
    }

    const DealListView = ({val,index}) =>{
      return(
        <div key={index} className='col-sm-12 col-lg-6 col-xl-6 col-md-12'>
            <div className={`card mt-5 ${val.premium_deal === 1 ? 'premium-deal-card' : 'deal-card'}`} style={{paddingTop:0}}>
                {val.hotdeal == 1 &&(
                <div class="hot-deal-label" 
                style={{
                  position: 'absolute',
                  top: '23px',
                  left: '-27px',
                  backgroundColor: '#14255d',
                  color: 'white',
                  padding: '5px 10px',
                  fontWeight: 'bold',
                  borderRadius: '5px',
                  zIndex:5,
                  width:'150px',
                  display:'flex',
                  alignItems:'center',
                  justifyContent:'center',
                  transform: 'rotate(-40deg)',
                  transformOrigin: 'center',
                  clipPath: 'polygon(17% 0, 77% 0, 100% 100%, 0 100%)',
                }}
                ><span>Hot Deal</span></div>
                )}
                {val.business_deal == 1 && (
                  <div className="biz-deal-label"
                  style={{
                    position: 'absolute',
                    top: '0px',
                    left: '15px',
                    // backgroundColor: 'rgb(207, 222, 255)',
                    backgroundColor: 'rgba(255, 255, 255, 1)',
                    border: '2px solid rgb(207, 222, 255)',
                    borderTop: '0',
                    color: '#000000',
                    padding: '5px 10px 10px 10px',
                    zIndex:5,
                    borderRadius: '0 0 15px 15px',
                  }}
                  >
                    <div className='d-flex flex-column align-items-center justify-content-center'>
                      <i class="bi bi-bookmark-star-fill" style={{fontSize:30,color:'#0033a1ff'}}></i>
                      <span style={{fontSize:12}}>Business</span>
                    </div>
                  </div>
                )}
                {val.premium_deal == 1 &&(
                <div class="premium-deal-label"><span>EXCLUSIVE</span></div>
                )}
                  <div className='ribbon ribbon-end ribbon-clip' style={{top: '10px'}}>
                    {val.status === 1 ? (
                      <div className='ribbon-label' style={{zIndex:2,borderRadius:25}}>
                        {val.deal_stock == 'true' ? 'In Stock' : 'Commitment Full'}
                        {val.deal_stock == 'true' ? (
                          <span className='ribbon-inner bg-info' style={{borderTopLeftRadius:25,borderBottomLeftRadius:25}}></span>
                        ) : (
                          <span className='ribbon-inner bg-warning' style={{borderTopLeftRadius:25,borderBottomLeftRadius:25}}></span>
                        )}
                      </div>
                    ) : (
                      <div className='ribbon-label' style={{zIndex:2,borderRadius:25}}>
                        Expired
                        <span className='ribbon-inner bg-danger' style={{borderTopLeftRadius:25,borderBottomLeftRadius:25}}></span>
                      </div>
                    )}
                  </div>
                  <div className='px-5 py-3'>
                    <div className={`card mt-5 ${val.premium_deal === 1 ? 'card card-body' : ''}`}>
                    <div className="row">
                      <div className="col-3">
                        <div className="">
                          <div className="text-center">
                          <img
                            src={val.default_color && val.default_color?.image}
                            alt='val.name'
                            style={{
                              width: '100%',
                              height: '125px',
                              maxHeight: '450px',
                              objectFit: 'contain',
                            }}
                          />
                        </div>
                        <div className="container-fluid text-left" style={{position:'relative',bottom:'5px',left:'-5px'}}>
                        {getDealLabel(val)}
                        </div>
                        </div>
                      </div>
                      <div className="col-9">
                        <div className='d-flex align-items-center'>
                          <div className='d-flex align-items-center flex-wrap w-100'>
                            <div className='px-3 flex-grow-1'>
                              <a className={`fs-5 fw-semibold text-hover-dark deal_description ${val.premium_deal === 1 ? 'text-dark' : 'text-gray-700'}`} style={{marginLeft:10}}>
                                {val.name}-{val?.default_color && val.default_color?.color}
                              </a>
                              <div className="container-fluid">
                                <div className="expire-date mb-2 mt-2">
                                <h5 className="fs-7 text-primary">Deal Expires : {formatDate(val.expires)}</h5>
                                </div>
        
                              </div>
                              <div className="row mt-3" style={{marginLeft:5}}>
                                <div className="col-lg-8">
                                <div className='d-flex flex-column justify-content-start mb-2'>
                                <span className={`fs-4 fw-bold ${val.premium_deal === 1 ? 'text-dark' : 'text-success'}`}>
                                  <CurrencyFormat
                                    decimalScale={2}
                                    value={itemPrice(val).orderPrice}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={'$'}
                                  />
                                  {(val.below_cost == 1 && itemPrice(val).actualPrice != 0) && (
                                  <span className="fs-8 py-1 px-2 ms-2" style={{color:'#ffffffff',borderRadius:8,backgroundColor:'#ff8484ff'}}>{getBelowCostPercentage(itemPrice(val).orderPrice,itemPrice(val).actualPrice)}</span>
                                    )}
                                  </span>
                                {itemPrice(val).orderPrice === itemPrice(val).actualPrice && (
                                  <h6 className="fs-8 text-gray-600">Price</h6>
                                )}
                                {itemPrice(val).status === 1 && itemPrice(val).orderPrice != itemPrice(val).actualPrice && (
                                  <span className='fs-4 text-muted text-decoration-line-through'>
                                    <CurrencyFormat
                                      decimalScale={2}
                                      value={itemPrice(val).actualPrice}
                                      displayType={'text'}
                                      thousandSeparator={true}
                                      prefix={'$'}
                                    />
                                  </span>
                                )}
                              </div>
                                </div>
                                <div className="col-lg-4">
                                  <h5 className={`fs-6 fw-bold ${val.premium_deal === 1 ? 'text-dark' : 'text-gray-800'}`}>
                                  <CurrencyFormat
                                        decimalScale={2}
                                        value={itemPrice(val).commission.toFixed(2)}
                                        // value={itemPrice(val).commission}
                                        displayType={'text'}
                                        thousandSeparator={true}
                                        prefix={'$'}
                                      />
                                  </h5>
                                  <h6 className="fs-8 text-gray-600">Commission</h6>
                                </div>
                              </div>
                              
                            </div>
                          </div>
                        </div>
                        <div className='d-flex align-items-center flex-end'>
                          {val.status === 1 ? (
                          <div className='d-flex justify-content-around'>
                            {val.deal_stock == 'true' && val.freezed_status == 1 && (
                                <button
                                onClick={() => {
                                  setShowCreateAppModal2(true)
                                  setPropsData(val)
                                }}
                                type='button'
                                className='deal-btn btn btn-dark text-white mt-2 ml-5'
                              >
                                Deal Freezed{' '}
                              </button>
                            )}
                            {val.deal_stock == 'true' && val.freezed_status == 0 && (
                              <>
                              <button onClick={() => {
                                setShowCreateAppModal(true)
                                setPropsData(val);
                                setChangedColor(val.default_color);
                                setChangedSize(val.default_color.sizes[0]);
                            }} type='button' className='commit-btn btn btn-warning mt-2 ms-3 me-3'
                            style={{background: 'linear-gradient(90deg, #f2994a 0%, #f2c94c 100%)'}}
                              >Commit&nbsp;&nbsp;<Send color={'white'} height="15px" width="15px" /></button>
                              <button
                              onClick={() => {
                                setShowCreateAppModal2(true)
                                setPropsData(val)
                              }}
                              type='button'
                              className='deal-btn btn btn-warning mt-2 ml-5'
                              style={{background: 'linear-gradient(90deg, #000046 0%, #1cb5e0 100%)'}}
                            >
                              View Deal&nbsp;&nbsp;<Eye color={'white'} height="15px" width="15px" />{' '}
                            </button>
                              </>
                            )}
                            {val.deal_stock == 'false' && val.freezed_status == 0 && (
                              <button
                                onClick={() => {
                                  setShowCreateAppModal2(true)
                                  setPropsData(val)
                                }}
                                type='button'
                                className='deal-btn btn btn-light  mt-2 ml-5'
                                style={{border: '2px solid rgba(129,45,227,1)',color:'rgba(129,45,227,1)'}}
                              >
                                Commitment Full{' '}
                              </button>
                            )}
                          </div>
                        ) : (
                          <div className="d-flex justify-content-around">
                          <button
                          onClick={() => {
                            setShowCreateAppModal2(true)
                            setPropsData(val)
                          }}
                          type='button'
                          className='deal-btn btn btn-light  mt-2 ml-5'
                          style={{border: '2px solid rgba(129,45,227,1)',color:'rgba(129,45,227,1)'}}
                        >
                          Expired{' '}
                        </button>
                        </div>
                        )}
                        
                      </div>
                      </div>
                    </div>
                    <div className="border-bottom my-3"></div>
                    <div className='d-flex flex-column mt-2'>
                      {/* <div className='text-dark fw-bold'>Stores</div> */}
                      <div className='d-flex'>
                        {val.default_color?.sizes[0].stores.map((item, index) => {
                          return (
                            <a
                              key={index}
                              href={item?.store_url}
                              target='_blank'
                              className='symbol symbol-40px me-2 card shadow-xs p-1'
                              style={{borderRadius:'50%'}}
                              data-bs-toggle='tooltip'
                              title={item?.store?.name}
                            >
                              <img
                                src={item?.store?.image}
                                alt='store'
                                style={{height: '30px', width: ' 30px'}}
                              />
                            </a>
                          )
                        })}
                      </div>
                    </div>
                    </div>
                  </div>
            </div>
        </div>
      )
    }

  return (
    <>
      <div className='d-flex align-items-center gap-2 gap-lg-3'>
        {showCreateAppModal && (
          <AddCommits
            show={showCreateAppModal}
            propsData={propsData}
            handleClose={() => {
              setShowCreateAppModal(false)
            }}
            changedColor={changedColor}
            changedSize={changedSize}
          />
        )}
        {showCreateAppModal2 && (
          <Details
            show2={showCreateAppModal2}
            propsData2={propsData}
            handleClose2={() => {
              setShowCreateAppModal2(false)
            }}
            setShowCreateAppModalCommit={setShowCreateAppModal}
            showCreateAppModalCommit={showCreateAppModal}
            setShowCreateAppModalTracking={setShowCreateAppModalTracking}
            showCreateAppModalTracking={showCreateAppModalTracking}
            setChangedColor={setChangedColor}
            setChangedSize={setChangedSize}
          />
        )}
        {showCreateAppModalTracking && (
          <AddTracking
            show={showCreateAppModalTracking}
            propsData={propsData}
            handleClose={() => {
              setShowCreateAppModalTracking(false)
            }}
            changedColor={changedColor}
            changedSize={changedSize}
          />
        )}
      </div>
      <div className='px-3'>
        <div className="row">
          <div className="col-lg-9 col-sm-12">
              <ul className='nav nav-tabs nav-line-tabs mb-5 fs-6'>
                <li className='nav-item'>
                    <a
                      className='nav-link active'
                      style={{cursor: 'pointer'}}
                      data-bs-toggle='tab'
                      href='#kt_tab_pane_4'
                      onClick={() => {
                        setLoading(true)
                        allActiveData()
                        setTimeout(() => {
                          setLoading(false)
                        }, 1000)
                      }}
                    >
                      All Deals
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      style={{cursor: 'pointer'}}
                      data-bs-toggle='tab'
                      href='#kt_tab_pane_1'
                      onClick={() => {
                        setLoading(true)
                        onRetailData()
                        setTimeout(() => {
                          setLoading(false)
                        }, 1000)
                      }}
                    >
                      On Retail
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      style={{cursor: 'pointer'}}
                      data-bs-toggle='tab'
                      href='#kt_tab_pane_3'
                      onClick={() => {
                        setLoading(true)
                        onCommissionData()
                        setTimeout(() => {
                          setLoading(false)
                        }, 1000)
                      }}
                    >
                      On Commission
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      style={{cursor: 'pointer'}}
                      data-bs-toggle='tab'
                      href='#kt_tab_pane_2'
                      onClick={() => {
                        setLoading(true)
                        belowCostData()
                        setTimeout(() => {
                          setLoading(false)
                        }, 1000)
                      }}
                    >
                      Below Cost
                    </a>
                  </li>
                  {hotDealExist &&(
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      style={{cursor: 'pointer'}}
                      data-bs-toggle='tab'
                      href='#kt_tab_pane_5'
                      onClick={() => {
                        setLoading(true)
                        hotDealsData()
                        setTimeout(() => {
                          setLoading(false)
                        }, 1000)
                      }}
                    >
                      <i class="bi bi-fire"></i>Hot Deals
                    </a>
                  </li>
                  
                  )}
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      style={{cursor: 'pointer'}}
                      data-bs-toggle='tab'
                      href='#kt_tab_pane_2'
                      onClick={() => {
                        setLoading(true)
                        onIphoneProData()
                        setTimeout(() => {
                          setLoading(false)
                        }, 1000)
                      }}
                    >
                      <i class="bi bi-stars"></i>iPhone Pro
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      style={{cursor: 'pointer'}}
                      data-bs-toggle='tab'
                      href='#kt_tab_pane_2'
                      onClick={() => {
                        setLoading(true)
                        onIphoneProMaxData()
                        setTimeout(() => {
                          setLoading(false)
                        }, 1000)
                      }}
                    >
                      <i class="bi bi-stars"></i>iPhone Pro Max
                    </a>
                  </li>
                </ul>
          </div>
          <div className="col-lg-3 col-sm-12 d-none d-lg-block">
            <div className="d-flex flex-end">
              <div>
                <input type="radio" className="btn-check" name="deal_view" id="option5" autocomplete="off" checked={dealView == 'card'} onChange={()=> setDealView('card')} />
                <label className={`px-3 py-2 cursor-pointer ${(dealView == 'card') ? 'bg-light-selected' : ''}`} style={{borderRadius:'20px 0 0 20px',border:'1px solid #c9e0fd'}} for="option5">
                  <i className={`bi bi-ui-radios-grid ${(dealView == 'card') ? 'text-primary' : 'text-secondary'}`}></i>&nbsp;&nbsp;Card View
                </label>
              </div>
              <div>
                <input type="radio" className="btn-check" name="deal_view" id="option6" autocomplete="off" checked={dealView == 'list'} onChange={()=> setDealView('list')} />
                <label className={`px-3 py-2 cursor-pointer ${(dealView == 'list') ? 'bg-light-selected' : ''}`} style={{borderRadius:'0 20px 20px 0',border:'1px solid #c9e0fd',borderLeft:'none'}} for="option6">
                  <i className={`bi bi-ui-radios ${(dealView == 'list') ? 'text-primary' : 'text-secondary'}`}></i>&nbsp;&nbsp;List View
                </label>
              </div>
            </div>
          </div>
        </div>
        
        <div className='row'>
          <div className='col-lg-6 col-md-6 col-sm-12'>
            <form>
              <input
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value.toLowerCase())}
                type='text'
                className='form-control'
                placeholder='Search...'
              />
            </form>
          </div>
          <div className='col-lg-6 col-md-6 col-sm-12'>
            <div style={{textAlign: 'right'}}>
              <Dropdown onSelect={handleSelect}>
                <Dropdown.Toggle variant='primary' id='dropdown-basic'>
                  {selectedFilter ? `Filter: ${selectedFilter}` : 'Select Filter'}
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item eventKey='All' className='text-gray-700'>All</Dropdown.Item>
                  <Dropdown.Item eventKey='In Stock' className='text-gray-700'>In Stock</Dropdown.Item>
                  <Dropdown.Item eventKey='Commitment Full' className='text-gray-700'>Commitment Full</Dropdown.Item>
                  <Dropdown.Item eventKey='Expired' className='text-gray-700'>Expired</Dropdown.Item>
                  {/* <Dropdown.Divider /> */}
                  <Dropdown.Item eventKey='Retail' className='text-gray-700'>Retail</Dropdown.Item>
                  <Dropdown.Item eventKey='Commission' className='text-gray-700'>Commission</Dropdown.Item>
                  <Dropdown.Item eventKey='Below Cost' className='text-gray-700'>Below Cost</Dropdown.Item>
                  {/* <Dropdown.Divider /> */}
                  <Dropdown.Item eventKey='iPhone Pro' className='text-gray-700'><i class="bi bi-stars"></i>iPhone Pro</Dropdown.Item>
                  <Dropdown.Item eventKey='iPhone Pro Max' className='text-gray-700'><i class="bi bi-stars"></i>iPhone Pro Max</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
          <div
            className='col-lg-6 col-md-6 col-sm-12 range_slider d-none'
            style={{position: 'relative'}}
          >
            <div className='thumb-values' style={{left: `${(sliderValues.from / 100000) * 100}%`}}>
              <span className='fw-bold'>${sliderValues.from}</span>
            </div>
            <div
              className='thumb-values'
              style={{left: `${(sliderValues.to / 100000) * 100 - 6}%`}}
            >
              <span className='fw-bold'>${sliderValues.to}</span>
            </div>
            <RangeSlider
              min={0}
              max={100000}
              step={10}
              value={[sliderValues.from, sliderValues.to]}
              onInput={(e) => {
                handleSliderChange(e)
              }}
            />
            <div className='thumb-values2'>
              <span className='fw-bold'>0%</span>
              <span className='fw-bold'>100%</span>
            </div>
          </div>
        </div>

        {/* On Sale Now Data */}
        {loading ? (
          <div className='item' style={{marginTop: '10%'}}>
            <Loader type='spinner-cub' bgColor={'#4168d1'} size={80} />
          </div>
        ) : (
          <div className='row'>
            {filteredData.length === 0 && (
              <div className='text-center mt-10'>
                <h3 className='text-gray-600'>No Deals Found...</h3>
              </div>
            )}
            {filteredData
              .filter((item) => {
                if (item === '') {
                  return item
                } else {
                  return item.name.toLowerCase().includes(searchValue.toLowerCase())
                }
              })
              // .filter((item) => {
              //   return (item.total >= (sliderValues.from) && item.total <= (sliderValues.to));
              // })
              .map((val, index) => {
                return (
                  <>
                  {(dealView == 'card') && (
                    <DealCardView val={val} index={index}/>
                  )}
                  {(dealView == 'list') && (
                    <DealListView val={val} index={index}/>
                  )}
                  </>
                )
              })}
          </div>
        )}
      </div>
    </>
  )
}

export default Deals
